import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import '../Styles/Nav.css'
import { isAuthenticated } from '../API_CALLS/apiHandler.js';
import { useNavigate } from 'react-router';
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

function Nav() {
    const [show, setShow] = useState(false);
    const { user, token } = isAuthenticated();
    // console.log(ngo);
    let navigate = useNavigate();
    const onLogout = event => {
        localStorage.clear();
        // navigate('/');
    }

    return (
        <div >
            <div className="navbar">
                <div className="navbar_heading">NGO Helpers</div>
                <div className="navbar_link">
                    <div className="nav_link">
                        <ul>
                            <li> <NavLink style={{ textDecoration: 'none' }} to="/"><span className="link">Home</span></NavLink></li>
                            <li> <NavLink style={{ textDecoration: 'none' }} to="/ngo"><span className="link">Ngo</span></NavLink></li>
                            <li> <NavLink style={{ textDecoration: 'none' }} to="/places"><span className="link">Places</span></NavLink></li>
                            {user == undefined ? <></> : <>{user.role === 1 ? <li> <NavLink style={{ textDecoration: 'none' }} to="/acceptedplaces"><span className="link">Accepted Places</span></NavLink></li> : <><li> <NavLink style={{ textDecoration: 'none' }} to="/myplaces"><span className="link">My Places</span></NavLink></li></>}</>}

                        </ul>
                    </div>
                    <div className="auth_link">
                        {user !== undefined ?
                            <>
                                <NavLink style={{ textDecoration: 'none' }} to="/auth/login"><span className="auth" onClick={onLogout}>Logout</span></NavLink>
                                {/* <span className="auth" onClick={onLogout}>Logout</span> */}
                                {/* <NavLink style={{ textDecoration: 'none' }} to="/profile"><span className="auth from_bottom">Profile</span></NavLink> */}
                            </>
                            :
                            <>
                                <NavLink style={{ textDecoration: 'none' }} to="/auth/login"><span className="auth">Login</span></NavLink>
                            </>
                        }

                    </div>
                </div>
                <div className="nav_toggle" onClick={() => setShow(!show)}>{show ? <><AiOutlineClose /></> : <><AiOutlineMenu /></>}</div>


            </div>
            {show ? <div className="other_Nav">
                <div className="nav_link">

                    <NavLink style={{ textDecoration: 'none' }} to="/"><span className="link">Home</span></NavLink>
                    <NavLink style={{ textDecoration: 'none' }} to="/ngo"><span className="link">Ngo</span></NavLink>
                    <NavLink style={{ textDecoration: 'none' }} to="/places"><span className="link">Places</span></NavLink>
                    {user == undefined ? <></> : <>{user.role === 1 ? <NavLink style={{ textDecoration: 'none' }} to="/acceptedplaces"><span className="link">Accepted Places</span></NavLink> : <> <NavLink style={{ textDecoration: 'none' }} to="/myplaces"><span className="link">My Places</span></NavLink></>}</>}


                </div>
                <div className="auth_link">
                    {user !== undefined ?
                        <>
                            <NavLink style={{ textDecoration: 'none' }} to="/auth/login"><span className="auth" onClick={onLogout}>Logout</span></NavLink>
                            {/* <span className="auth" onClick={onLogout}>Logout</span> */}
                            {/* <NavLink style={{ textDecoration: 'none' }} to="/profile"><span className="auth from_bottom">Profile</span></NavLink> */}
                        </>
                        :
                        <>
                            <NavLink style={{ textDecoration: 'none' }} to="/auth/login"><span className="auth">Login</span></NavLink>
                        </>
                    }

                </div>
            </div> : <></>}

            <Outlet />
        </div>
    );
}

export default Nav;